import {
  Card,
  CardContent,
  CardHeader,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { useRedirect, useDataProvider } from "react-admin";

const ScanQR = () => {
  const redirect = useRedirect();
  const dataProvider = useDataProvider();
  const qrRef = useRef(null);

  const [presensi, setPresensi] = useState([]);

  // ===== helper tanggal hari ini =====
  const now = new Date();
  const todayISO = now.toISOString().slice(0, 10); // YYYY-MM-DD

  console.log("todayISO:", todayISO);


  const hariTanggal = now.toLocaleDateString("id-ID", {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  // ===== ambil presensi hari ini =====
  useEffect(() => {
    dataProvider
      .getList("presensi_pojok", {
        pagination: { page: 1, perPage: 50 },
        sort: { field: "date_created", order: "DESC" },
        filter: {
          tanggal: todayISO, // sesuaikan dengan backend
        },
      })
      .then(({ data }) => {
        setPresensi(data);
      })
      .catch((err) => {
        console.error("Gagal load presensi:", err);
      });
  }, [dataProvider, todayISO]);

  // ===== QR Scanner =====
  const startScan = async () => {
    if (qrRef.current) return;

    const qr = new Html5Qrcode("qr-reader");
    qrRef.current = qr;

    try {
      await qr.start(
        { facingMode: "environment" },
        { fps: 10, qrbox: 250 },
        (decodedText) => {
          qr.stop().then(() => {
            qrRef.current = null;
            redirect(`/presensi_pojok/create?date=${decodedText}`);
          });
        }
      );
    } catch (err) {
      console.error("Camera error:", err);
      alert("Gagal membuka kamera");
    }
  };

  const tambahSatuJam = (dateString) => {
  if (!dateString) return "-";

  const date = new Date(dateString.replace(" ", "T"));
  date.setHours(date.getHours() + 1);

  return date.toTimeString().slice(0, 5); // HH:mm
};


  return (
    <Card sx={{ mt: 2 }}>
      <CardHeader title="Scan QR Code Presensi Agesta" />
      <CardContent>
        <Button variant="contained" onClick={startScan} sx={{ mb: 2 }}>
          Mulai Scan
        </Button>

        <div id="qr-reader" style={{ width: "100%", minHeight: 300 }} />

        {/* ===== PRESENSI HARI INI ===== */}
        <Typography variant="h6" sx={{ mt: 4, mb: 1 }}>
          Presensi Hari Ini
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {hariTanggal}
        </Typography>

        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Username</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Jam</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {presensi.length === 0 && (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  Belum ada presensi
                </TableCell>
              </TableRow>
            )}

            {presensi.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.username}</TableCell>
                <TableCell>{row.status}</TableCell>
                <TableCell>{tambahSatuJam(row.date_created)}</TableCell>

              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default ScanQR;
